/**
 * http 包内无 Vue 依赖的 t()，文案表在本目录 locales；选语言逻辑在 common-utils。
 */
import zhCn from './locales/zh_cn.js'
import zhTc from './locales/zh_tc.js'
import enUs from './locales/en_us.js'
import { createPlainTranslator } from '@repo/common-utils/utils/plainI18n'

const tImpl = createPlainTranslator({ zhCn, zhTc, en: enUs })

/** @param {string} key 点分路径，如 requestCode.dlsxqcxdl */
export function t(key) {
  return tImpl(key)
}
